<template>
  <v-card class="elevation-12">
    <RegistryPermissionDataTable
    />
  </v-card>
</template>


<script>
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import RegistryPermissionDataTable from "@/components/registry-permission/RegistryPermissionDataTable.vue";

export default {
  name: "RegistryPermission",
  components: {
    RegistryPermissionDataTable,
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('registryPermission.pageTitle'))
  }
}
</script>